// exports ClientSource - an immutable object 'enum'
// usage: import { ClientSource } from '../../enums/ClientSource';
const clientSource = {
    100: 'BCBSM',
    101: 'BCN'
};
Object.freeze(clientSource);
export const ClientSource = clientSource;